import mapActions from './mapActions';

export default mapActions('working_hours', {
    fetchAll_url: (data) => {
        return `/api/working_hours/employees/${data.id}/${data.year}/${data.month}`;}
});